// @flow

import { MediaQuery } from '@riseart/common';
import { Col, Row } from '@riseart/antd-provider';
import { FilterExpandable, FilterExpandableContent } from '@riseart/filter';
import {
  CLEAR_BUTTON_TYPE,
  CLEAR_LINK_TYPE,
  FILTER_ITEM_TYPE,
  FILTER_EXPANDABLE_FOOTER_TYPE,
  SEARCH_LINK,
} from 'shared_models/filters/preconfigTypes';

import {
  raScreenSmMax,
  raScreenMd,
  raScreenMdMax,
  raScreenLg,
  raScreenLgMax,
  raScreenXl,
} from '@riseart/antd-provider/dist/website/variables.less';
import { filterColCenterCls } from 'shared_models/filters/styles.less';

export const ArtListFilterModel = [
  {
    type: MediaQuery,
    props: { minWidth: 0 },
    items: [
      {
        type: MediaQuery,
        props: { maxWidth: raScreenSmMax },
        items: [
          {
            type: Row,
            props: { type: 'flex', justify: 'space-between', gutter: 32 },
            items: [
              {
                type: Col,
                props: { span: 24 },
                items: [{ ...FILTER_ITEM_TYPE, props: { dimension: 'price', marks: false } }],
              },
              {
                type: Col,
                props: { span: 13 },
                items: [{ ...FILTER_ITEM_TYPE, props: { dimension: 'size' } }],
              },
              {
                type: Col,
                props: { span: 11 },
                items: [{ ...FILTER_ITEM_TYPE, props: { dimension: 'medium' } }],
              },
            ],
          },
          {
            type: FilterExpandable,
            props: { type: 'flex', justify: 'space-between', gutter: 32 },
            items: [
              {
                type: FilterExpandableContent,
                items: [
                  {
                    type: Row,
                    props: { type: 'flex', justify: 'space-between', gutter: 32 },
                    items: [
                      {
                        type: Col,
                        props: { span: 13 },
                        items: [
                          { ...FILTER_ITEM_TYPE, props: { dimension: 'height', marks: false } },
                        ],
                      },
                      {
                        type: Col,
                        props: { span: 11 },
                        items: [{ ...FILTER_ITEM_TYPE, props: { dimension: 'subject' } }],
                      },
                      {
                        type: Col,
                        props: { span: 13 },
                        items: [
                          { ...FILTER_ITEM_TYPE, props: { dimension: 'width', marks: false } },
                        ],
                      },
                      {
                        type: Col,
                        props: { span: 11 },
                        items: [{ ...FILTER_ITEM_TYPE, props: { dimension: 'style' } }],
                      },
                      {
                        type: Col,
                        props: { span: 13, className: filterColCenterCls },
                        items: [
                          {
                            ...FILTER_ITEM_TYPE,
                            props: { dimension: 'orientation', showLabel: false },
                          },
                        ],
                      },
                      {
                        type: Col,
                        props: { span: 6 },
                        items: [{ ...FILTER_ITEM_TYPE, props: { dimension: 'color' } }],
                      },
                      {
                        type: Col,
                        props: { span: 5, align: 'center' },
                        items: [SEARCH_LINK],
                      },
                      {
                        type: Col,
                        props: { span: 13 },
                        items: [{ ...FILTER_ITEM_TYPE, props: { dimension: 'ships' } }],
                      },
                    ],
                  },
                ],
              },
              {
                ...FILTER_EXPANDABLE_FOOTER_TYPE,
                items: [CLEAR_LINK_TYPE],
              },
            ],
          },
        ],
      },
      {
        type: MediaQuery,
        props: { minWidth: raScreenMd, maxWidth: raScreenMdMax },
        items: [
          {
            type: Row,
            props: { type: 'flex', justify: 'space-between', gutter: 32 },
            items: [
              {
                type: Col,
                props: { span: 8 },
                items: [{ ...FILTER_ITEM_TYPE, props: { dimension: 'size' } }],
              },
              {
                type: Col,
                props: { span: 8 },
                items: [{ ...FILTER_ITEM_TYPE, props: { dimension: 'height', marks: false } }],
              },
              {
                type: Col,
                props: { span: 8 },
                items: [{ ...FILTER_ITEM_TYPE, props: { dimension: 'width', marks: false } }],
              },
              {
                type: Col,
                props: { span: 8 },
                items: [{ ...FILTER_ITEM_TYPE, props: { dimension: 'price', marks: false } }],
              },
              {
                type: Col,
                props: { span: 8 },
                items: [{ ...FILTER_ITEM_TYPE, props: { dimension: 'medium' } }],
              },
              {
                type: Col,
                props: { span: 8 },
                items: [{ ...FILTER_ITEM_TYPE, props: { dimension: 'subject' } }],
              },
            ],
          },
          {
            type: FilterExpandable,
            props: { type: 'flex', justify: 'space-between', gutter: 32 },
            items: [
              {
                type: FilterExpandableContent,
                items: [
                  {
                    type: Row,
                    props: { type: 'flex', justify: 'flex-start', gutter: 32 },
                    items: [
                      {
                        type: Col,
                        props: { span: 8 },
                        items: [{ ...FILTER_ITEM_TYPE, props: { dimension: 'style' } }],
                      },
                      {
                        type: Col,
                        props: { span: 8 },
                        items: [{ ...FILTER_ITEM_TYPE, props: { dimension: 'ships' } }],
                      },
                      {
                        type: Col,
                        props: { span: 4 },
                        items: [
                          {
                            ...FILTER_ITEM_TYPE,
                            props: { dimension: 'orientation', showLabel: false },
                          },
                        ],
                      },
                      {
                        type: Col,
                        props: { span: 4 },
                        items: [
                          {
                            ...FILTER_ITEM_TYPE,
                            props: { dimension: 'color', showLabel: false },
                          },
                        ],
                      },
                      {
                        type: Col,
                        props: { span: 24, align: 'right' },
                        items: [SEARCH_LINK],
                      },
                    ],
                  },
                ],
              },
              {
                ...FILTER_EXPANDABLE_FOOTER_TYPE,
                items: [CLEAR_LINK_TYPE],
              },
            ],
          },
        ],
      },
      {
        type: MediaQuery,
        props: { minWidth: raScreenLg, maxWidth: raScreenLgMax },
        items: [
          {
            type: Row,
            props: { type: 'flex', justify: 'space-between', gutter: 32 },
            items: [
              {
                type: Col,
                props: { span: 6 },
                items: [{ ...FILTER_ITEM_TYPE, props: { dimension: 'size' } }],
              },
              {
                type: Col,
                props: { span: 6 },
                items: [{ ...FILTER_ITEM_TYPE, props: { dimension: 'height', marks: false } }],
              },
              {
                type: Col,
                props: { span: 6 },
                items: [{ ...FILTER_ITEM_TYPE, props: { dimension: 'width', marks: false } }],
              },
              {
                type: Col,
                props: { span: 6 },
                items: [{ ...FILTER_ITEM_TYPE, props: { dimension: 'price', marks: false } }],
              },
            ],
          },
          {
            type: Row,
            props: { type: 'flex', justify: 'space-between', gutter: 32 },
            items: [
              {
                type: Col,
                props: { span: 6 },
                items: [{ ...FILTER_ITEM_TYPE, props: { dimension: 'medium', align: 'left' } }],
              },
              {
                type: Col,
                props: { span: 6 },
                items: [{ ...FILTER_ITEM_TYPE, props: { dimension: 'style' } }],
              },
              {
                type: Col,
                props: { span: 6 },
                items: [{ ...FILTER_ITEM_TYPE, props: { dimension: 'subject' } }],
              },
              {
                type: Col,
                props: { span: 3 },
                items: [
                  {
                    ...FILTER_ITEM_TYPE,
                    props: { dimension: 'orientation', showLabel: false },
                  },
                ],
              },
              {
                type: Col,
                props: { span: 3 },
                items: [
                  {
                    ...FILTER_ITEM_TYPE,
                    props: { dimension: 'color', showLabel: false },
                  },
                ],
              },
            ],
          },
          {
            type: FilterExpandable,
            props: { type: 'flex', justify: 'space-between', gutter: 32 },
            items: [
              {
                type: FilterExpandableContent,
                items: [
                  {
                    type: Row,
                    props: { type: 'flex', justify: 'flex-start', gutter: 32 },
                    items: [
                      {
                        type: Col,
                        props: { span: 6 },
                        items: [
                          { ...FILTER_ITEM_TYPE, props: { dimension: 'ships', align: 'left' } },
                        ],
                      },
                      {
                        type: Col,
                        props: { span: 18, align: 'right' },
                        items: [SEARCH_LINK],
                      },
                    ],
                  },
                ],
              },
              {
                ...FILTER_EXPANDABLE_FOOTER_TYPE,
                items: [CLEAR_LINK_TYPE],
              },
            ],
          },
        ],
      },
      {
        type: MediaQuery,
        props: { minWidth: raScreenXl },
        items: [
          {
            type: Row,
            props: { type: 'flex', justify: 'space-between', gutter: 32 },
            items: [
              {
                type: Col,
                props: { span: 4 },
                items: [{ ...FILTER_ITEM_TYPE, props: { dimension: 'size' } }],
              },
              {
                type: Col,
                props: { span: 5 },
                items: [{ ...FILTER_ITEM_TYPE, props: { dimension: 'height', marks: false } }],
              },
              {
                type: Col,
                props: { span: 5 },
                items: [{ ...FILTER_ITEM_TYPE, props: { dimension: 'width', marks: false } }],
              },
              {
                type: Col,
                props: { span: 5 },
                items: [{ ...FILTER_ITEM_TYPE, props: { dimension: 'price', marks: false } }],
              },
              {
                type: Col,
                props: { span: 5 },
                items: [{ ...FILTER_ITEM_TYPE, props: { dimension: 'orientation' } }],
              },
            ],
          },
          {
            type: Row,
            props: { type: 'flex', justify: 'space-between', gutter: 32 },
            items: [
              {
                type: Col,
                props: { span: 4 },
                items: [{ ...FILTER_ITEM_TYPE, props: { dimension: 'medium' } }],
              },
              {
                type: Col,
                props: { span: 5 },
                items: [{ ...FILTER_ITEM_TYPE, props: { dimension: 'style' } }],
              },
              {
                type: Col,
                props: { span: 5 },
                items: [{ ...FILTER_ITEM_TYPE, props: { dimension: 'subject' } }],
              },
              {
                type: Col,
                props: { span: 5 },
                items: [{ ...FILTER_ITEM_TYPE, props: { dimension: 'ships' } }],
              },
              {
                type: Col,
                props: { span: 2 },
                items: [{ ...FILTER_ITEM_TYPE, props: { dimension: 'color' } }],
              },
              {
                type: Col,
                props: { span: 1 },
                items: [SEARCH_LINK],
              },
              {
                type: Col,
                props: { span: 2 },
                items: [CLEAR_BUTTON_TYPE],
              },
            ],
          },
        ],
      },
    ],
  },
];
